import { render, staticRenderFns } from "./liste-champs-modele-examen.html?vue&type=template&id=b2c3a79c&scoped=true&external"
import script from "./liste-champs-modele-examen.js?vue&type=script&lang=js&external"
export * from "./liste-champs-modele-examen.js?vue&type=script&lang=js&external"
import style0 from "./liste-champs-modele-examen.scss?vue&type=style&index=0&id=b2c3a79c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c3a79c",
  null
  
)

export default component.exports